var map = {
	"./core/Drawer.vue": 1479,
	"./core/Filter.vue": 1483,
	"./core/Footer.vue": 1487,
	"./core/Toolbar.vue": 1491,
	"./core/View.vue": 1495,
	"./helper/Offset.vue": 1499,
	"./material/Card.vue": 535,
	"./material/ChartCard.vue": 1506,
	"./material/Notification.vue": 1510,
	"./material/StatsCard.vue": 1514
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1478;


//////////////////
// WEBPACK FOOTER
// ./VueSrc/Common/Components/materialcomponents/components \.vue$
// module id = 1478
// module chunks = 0